














































































































import { mapState } from "vuex";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import IconInvested from "@/common/components/icons/IconInvested.vue";
import IconGive from "@/common/components/icons/IconGive.vue";
import IconGiven from "@/common/components/icons/IconGiven.vue";
import A01PointWithIconPanel from "@/general/components/pages/parts/Top/A01PointWithIconPanel.vue";

import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { getThanksPointName, getThanksOnlyPointName } from "@/common/assets/js/utils/pointName";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";

@Component({
  name: "TheA01PointInfoPanel",
  components: {
    PointNotation,
    IconBase,
    IconArrowRight,
    IconInvested,
    IconGive,
    IconGiven,
    A01PointWithIconPanel
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class TheA01PointInfoPanel extends Vue {
  @Prop({ type: Object, required: true })
  sumPoints!: any;
  @Prop({ type: Number, required: true })
  pointsExpiringSoon!: number;
  @Prop({ type: Number, required: true, default: 0 })
  pointsExpiringCount!: number;
  @Prop({ type: Number, required: true })
  point!: number;
  @Prop({ type: Number, required: true, default: 0 })
  grantPoint!: number;
  @Prop({ type: Number, required: true, default: 0 })
  thanksExclusivePoint!: number;
  storeColorCode: string;

  get pointNotationStyle() {
    if (this.isSp == "sp") {
      return {
        iconSize: 24,
        fontSize: 32
      };
    } else {
      return {
        iconSize: 32,
        fontSize: 32
      };
    }
  }

  get isSp() {
    return commons.isLargeBreakpointWidthOfSp;
  }
  get unit() {
    return commons.OrgPageSpecific?.point_name;
  }

  get urlExpiring() {
    return CONST_DATA.SITE_MAP.EXPIRING_POINTS;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get thanksExclusivePointsEnable() {
    return auth.user?.thanks_exclusive_points_enabled;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  get thanksOnlyPointName() {
    return getThanksOnlyPointName(CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME1);
  }
}
